import { render, staticRenderFns } from "./ImporterInput.vue?vue&type=template&id=5555f53a&scoped=true&"
import script from "./ImporterInput.vue?vue&type=script&lang=js&"
export * from "./ImporterInput.vue?vue&type=script&lang=js&"
import style0 from "./ImporterInput.vue?vue&type=style&index=0&id=5555f53a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5555f53a",
  null
  
)

export default component.exports